import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { authApi } from '../services/api';
import Spinner from './Spinner';

interface ProtectedRouteProps {
    children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
    const [isLoading, setIsLoading] = useState(true);
    const location = useLocation();

    useEffect(() => {
        const checkAuth = async () => {
            try {
                const response = await authApi.getAccountInfo();
                setIsAuthenticated(response.status === 'success');
            } catch (error) {
                setIsAuthenticated(false);
            } finally {
                setIsLoading(false);
            }
        };

        checkAuth();
    }, []);

    if (isLoading) {
        return (
            <div className='min-h-screen flex items-center justify-center' style={{ backgroundColor: '#1D1A31' }}>
                <Spinner size='lg' color='white' />
            </div>
        );
    }

    if (!isAuthenticated) {
        // Save the current location (including search params) as the return URL
        const returnUrl = location.pathname + location.search;
        return <Navigate to={`/login?returnUrl=${encodeURIComponent(returnUrl)}`} replace />;
    }

    return <>{children}</>;
};

export default ProtectedRoute;

